import { LocalNotifications } from '@capacitor/local-notifications';

export async function scheduleLocalNotification(
  title: string, 
  body: string, 
  scheduledTime: Date,
  notificationId?: number
) {
  await LocalNotifications.requestPermissions();

  await LocalNotifications.schedule({
    notifications: [
      {
        id: notificationId || Date.now(),
        title: title,
        body: body,
        schedule: { at: scheduledTime },
        sound: undefined,
        attachments: undefined,
        actionTypeId: '',
        extra: null,
      },
    ],
  });
}

export async function cancelLocalNotification(notificationId: number) {
  await LocalNotifications.cancel({ notifications: [{ id: notificationId }] });
}

export async function pushLocalNotification(title: string, body: string) {
  await LocalNotifications.requestPermissions();

  await LocalNotifications.schedule({
    notifications: [
      {
        id: Date.now(),
        title: title,
        body: body,
        schedule: { at: new Date(new Date().getTime() + 1000) },
        sound: undefined,
        attachments: undefined,
        actionTypeId: '',
        extra: null,
      },
    ],
  });
}
